import { Spine } from '@esotericsoftware/spine-pixi-v8';
import {
    BitmapText,
    Container, /*Sprite,*/ Graphics
} from 'pixi.js';
import { Tween /*, Group/*, Easing*/ } from "tweedle.js";
import { /*getSymbol,*/ getSpineSymbol /*, isOversizeSymbol*/ } from "../../config/getSymbol";
import { fsInitIndex, RespinIndex } from '../../config/GlobalVariableConfig';
import { spinData } from '../../server/getServerResposesFun';
// import { /*spinResponse,*/ initData/*, SpinDataObject/*, spinData /*, WinObject*/ } from '../server/getServerResposesFun'
import gsap from "gsap";
import { MotionPathPlugin } from "gsap/all";
import { EventEmitter } from "pixi.js";


export const reelSpinEmitter = new EventEmitter();

// import { sound } from '@pixi/sound';
import {
    // MULTIPLIER1_FONT,
    // MULTIPLIER1_POS,
    // MULTIPLIER2_FONT,
    // MULTIPLIER2_POS,
    // MULTIPLIER3_POS,
    // MULTIPLIER4_POS,
    REEL_DIVIDER,
    REEL_FRAME,
    REEL_NUMBERS,
    REEL_WIDTH,
    SYMBOL_HEIGHT,
    SYMBOL_WIDTH,
    // REEL_COLLECTION_COUNT,
    SYMBOLS_PER_REEL,
} from "../../config/reelConfig";

const reelSymbols = [
    [3, 6, 1, 3, 6, 8, 3, 6, 3, 6, 8, 1, 6, 3, 8, 6, 1, 6, 8, 3, 6, 1, 3, 8, 6, 1, 3, 8, 6, 3, 1, 6, 8, 3, 6, 1, 3, 8, 1, 3, 8, 6, 1, 3, 8, 3, 6, 3, 1, 8, 3, 6, 8, 1, 3, 8, 3, 6, 8, 1, 3, 6, 8, 1, 3, 6, 8, 3, 6, 8, 3, 3, 6, 8, 1, 3, 6, 8, 3, 1, 8, 3]
    , [2, 7, 4, 2, 7, 2, 7, 2, 4, 7, 2, 7, 4, 2, 7, 4, 7, 2, 7, 4, 2, 7, 2, 4, 7, 2, 7, 4, 2, 7, 4, 2, 2, 7, 4, 2, 7, 2, 4, 7, 2, 4, 7, 2, 2, 7, 2, 4, 2, 7, 4, 2, 2, 7, 2, 7, 4, 2, 7, 2, 4, 2]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
]

/*const reelSymbols = [
    [24, 24, 24, 24, 24, 24, 24]
    , [24, 24, 24, 24, 24, 24, 24]
    , [24, 24, 24, 24, 24, 24, 24]
    , [24, 24, 24, 24, 24, 24, 24]
    , [24, 24, 24, 24, 24, 24, 24]
    , [24, 24, 24, 24, 24, 24, 24]
]*/

export interface SymbolObject {
    symbolIndex: number // this is symbol position number in the array 0,1,2..
    id: number; // this is symbol id number mapped with backend
    y: number
    view: Container;
    symbol: Spine;
    isWin: boolean;
    // multText: BitmapText;
    // multVal: number;
}

export interface ReelObject {
    container: Container;
    mask: Graphics;
    reelIndex: number
    // reelCollections: Container[];
    symbols: SymbolObject[];
    // symbolSprites : Sprite[];
    // symbolPositions : number[];
    // position: number;
    // nextPosition: number;
    // time: number;
    settled: boolean;
    // blurFilter: BlurFilter;
    tween: Tween<any> | null;
}

gsap.registerPlugin(MotionPathPlugin);

export class ReelInit extends Container {

    public allReelArray: ReelObject[];
    public reelOverlayContainer: Container;
    public paylineOverlayContainer: Container;
    public anticipation: Spine[];

    private allReelContainer: Container;
    public wildBoundaryContainer: Container;
    public wildArcMask: Graphics | null = null;

    public accuWinVal: number = 0;
    public accumWinText: BitmapText = new BitmapText({
        text: "",
        style: {
            fontFamily: 'symbol_multiplier',
            fontSize: 40,
        }
    });

    // public winPatch: Sprite;
    // private multiplier1: BitmapText | null = null;
    // private multiplier2: BitmapText | null = null;
    // private multiplier3: BitmapText | null = null;
    // private multiplier4: BitmapText | null = null;
    // private multiplier5: BitmapText | null = null;
    public gameMultiplierValues: number[] = [];
    public gameMultiplierTexts: BitmapText[] = [];
    public gameMultiplierFx: Spine[] = [];
    // public reactMarkOnReelStop: Graphics = new Graphics();
    // public reactMarkOnReelSpin: Graphics = new Graphics();
    // private multiplierContainer: Container;



    constructor() {
        super();
        this.allReelContainer = new Container();
        this.allReelArray = [];
        this.reelOverlayContainer = new Container();
        this.anticipation = [];
        this.paylineOverlayContainer = new Container();

        // this.reelOverlayContainer.visible=false;

        this.initReels();

    }


    private initReels() {
        // this.winPatch = Sprite.from('opa_winPatch');
        // this.winPatch.position.set(475, 882);
        // this.winPatch.scale.set(1.1);
        // this.winPatch.anchor = 0.5;
        // this.winPatch.visible = false; // Initially hidden
        //this.addChild(this.winPatch);

        this.accumWinText.position.set(420, 905);
        this.accumWinText.label = "accumWinText";
        this.accumWinText.anchor = 0.5;
        //this.addChild(this.accumWinText);



        // this.multiplierFx.state.setAnimation(0, "multiplier_meter_fx", true);

        // const scale = Math.min(410 / this.accumWinText.width, 1);
        // this.accumWinText.scale = scale

        for (let i = 0; i < REEL_NUMBERS; i++) {
            const reelContainer = new Container();
            const reelObj: ReelObject = {
                container: reelContainer,
                mask: new Graphics(),
                reelIndex: i,
                // reelCollections: [],
                symbols: [],
                // symbolSprites: [],
                // symbolPositions: [],
                // position: 0,
                // nextPosition: 0,
                // time: 0,
                settled: true,
                // blurFilter: new BlurFilter(),
                tween: null
            };

            // reelObj.blurFilter.strength = 0;
            // reelContainer.filters = [reelObj.blurFilter];
            reelContainer.x = REEL_FRAME + i * (REEL_WIDTH + REEL_DIVIDER);
            reelContainer.y = REEL_FRAME;

            // const additionalHeight = 5;
            const mask = new Graphics().rect(0, 0, REEL_WIDTH, SYMBOL_HEIGHT * SYMBOLS_PER_REEL).fill(0x950a5a);
            reelContainer.addChild(mask);
            mask.alpha = 0.5;
            reelObj.mask = mask;

            reelContainer.mask = reelObj.mask;

            // // remove the mask
            mask.alpha = 0;
            reelContainer.mask = null;

            // reelContainer.visible = false;  // later make it enabled- > reels will be false

            // for (let k = 0; k < REEL_COLLECTION_COUNT; k++) {
            // const reelCollectionContainer = new Container();

            const reelRand = Math.floor(Math.random() * (reelSymbols[i].length - SYMBOLS_PER_REEL));
            let reelSymbolIds = RespinIndex.value === 0 ?
                reelSymbols[i].slice(reelRand, reelRand + SYMBOLS_PER_REEL)
                :
                fsInitIndex != 0 ? spinData.respins[fsInitIndex - 2].reelSymbols[i] : spinData.respins[RespinIndex.value - 2].reelSymbols[i];

            if (Array.isArray(reelSymbolIds) && reelSymbolIds.every(num => typeof num === 'number')) {
                // console.log("reelSymbolIds is an array of numbers");
            } else {
                reelSymbolIds = reelSymbols[i].slice(reelRand, reelRand + SYMBOLS_PER_REEL)
            }

            if (reelSymbolIds)


                for (let j = 0; j < SYMBOLS_PER_REEL; j++) {
                    // const predefinedReelImageData = initData .reelSymbols ? initData.reelSymbols[i] : undefined;
                    // if (predefinedReelImageData) {
                    //     reelObj.symbols.id = predefinedReelImageData;
                    // }

                    // let symbol: Sprite;
                    // if (k == 0) {
                    //     const symbolId = Math.floor(Math.random() * NUMBER_OF_SYMBOLS);
                    //     symbol = Sprite.from(getSymbol(symbolId));
                    //     reelObj.symbols[j] = symbolId;
                    // } else {
                    //     // symbol = new Sprite(getSymbol(Math.floor(Math.random() * NUMBER_OF_SYMBOLS)));
                    //     symbol = new Sprite();

                    // }

                    const symbolContainer = new Container();

                    const symbolId = reelSymbolIds[j];
                    // let symbol = Sprite.from(getSymbol(symbolId));

                    let symbol = getSpineSymbol(symbolId);
                    symbol.state.setAnimation(0, "land", false);


                    symbolContainer.addChild(symbol);
                    // reelObj.symbols[j].id = symbolId;

                    // symbol.anchor = 0.5;
                    symbolContainer.y = (SYMBOL_HEIGHT / 2) + j * SYMBOL_HEIGHT;
                    symbolContainer.x = Math.round(SYMBOL_WIDTH / 2);

                    // const textval = new BitmapText({
                    //     text: '',
                    //     style: {
                    //         fontFamily: 'forbidden_symbol_multiplier',
                    //         fontSize: 65
                    //     }
                    // });

                    // textval.anchor = 0.5;
                    // textval.position.set(0, -30);
                    // symbolContainer.addChild(textval);

                    const symbolObj: SymbolObject = {

                        symbolIndex: j,
                        id: symbolId,
                        y: symbolContainer.y,
                        view: symbolContainer,
                        symbol: symbol,
                        isWin: false,
                        // multText: textval,
                        // multVal: 0,
                    }

                    reelObj.symbols.push(symbolObj);

                    reelContainer.addChild(symbolContainer);


                }

            // chnaging order of cells, making symbols on top of cells
            reelObj.symbols.forEach((symbol) => {
                reelContainer.addChild(symbol.view);
            })

            // reelContainer.addChild(reelCollectionContainer);
            // reelObj.reelCollections.push(reelCollectionContainer);
            // }

            this.allReelContainer.addChild(reelContainer);
            this.allReelArray.push(reelObj);

            this.anticipation[i] = Spine.from({
                skeleton: "expWildFxSkel",
                atlas: "expWildFxAtlas",
            });

            // this.anticipation[i].state.setAnimation(0, "expanding_fx", true);

            this.anticipation[i].x = REEL_FRAME + i * (REEL_WIDTH + REEL_DIVIDER);
            this.anticipation[i].y = REEL_FRAME;

        }




        // const markOffset = 15;
        // const addtionalHeight = 5;
        // this.reactMarkOnReelStop = new Graphics().rect(REEL_FRAME, REEL_FRAME - markOffset, REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * REEL_DIVIDER, addtionalHeight + markOffset + SYMBOL_HEIGHT * SYMBOLS_PER_REEL).fill(0x950a5a);
        // this.allReelContainer.addChild(this.reactMarkOnReelStop);
        // this.reactMarkOnReelStop.alpha = 0.5;
        // this.allReelContainer.mask = this.reactMarkOnReelStop;



        // const addtionalHeightReelSpin = 5;
        // this.reactMarkOnReelSpin = new Graphics().rect(REEL_FRAME, REEL_FRAME + addtionalHeightReelSpin, REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * REEL_DIVIDER, addtionalHeight + SYMBOL_HEIGHT * SYMBOLS_PER_REEL).fill(0x950a5a);
        // this.allReelContainer.addChild(this.reactMarkOnReelSpin);
        // this.reactMarkOnReelSpin.alpha = 0;
        // this.allReelContainer.mask = this.reactMarkOnReelSpin;

        // this.allReelContainer.scale=0.35;
        // this.allReelContainer.y = this.allReelContainer.y+100;
        // this.setupMultipliers();
        this.addChild(this.allReelContainer);


        this.reelOverlayContainer.destroy(true);
        // this.reelOverlayContainer = new Container();

        this.initReelOverlayContainer();

        this.paylineOverlayContainer.destroy(true);
        // for (let i = 0; i < REEL_NUMBERS; i++) {
        //     this.addReelSymbolsToContainer(i);
        // }
        if (fsInitIndex != 0) {
            // console.log("spinData.respins ", spinData.respins);
            // console.log("fsInitIndex - 2", (fsInitIndex - 2), " spinData.respins[fsInitIndex - 2].gameMultipliers ", spinData.respins[fsInitIndex - 2].gameMultipliers);
            // this.gameMultiplierValues = spinData.respins[fsInitIndex - 2].gameMultipliers;
            // this.gameMultiplierTexts[0].text = this.gameMultiplierValues[0] ? this.gameMultiplierValues[0] + "X" : this.gameMultiplierTexts[0].text;
            // this.gameMultiplierTexts[1].text = this.gameMultiplierValues[1] ? this.gameMultiplierValues[1] + "X" : this.gameMultiplierTexts[1].text;
            // this.gameMultiplierTexts[2].text = this.gameMultiplierValues[2] ? this.gameMultiplierValues[2] + "X" : this.gameMultiplierTexts[2].text;
            // this.gameMultiplierTexts[3].text = this.gameMultiplierValues[3] ? this.gameMultiplierValues[3] + "X" : this.gameMultiplierTexts[3].text;

            // this.setTheScleOfMainMultiplier();

        }
        // this.setupMultiplierEffects();
        // this.addChild(this.winPatch);
        this.addChild(this.accumWinText);
    }

    // private setTheScleOfMainMultiplier(): void {
    //     this.gameMultiplierTexts[0].scale = 1;
    //     const scale = Math.min(120 / this.gameMultiplierTexts[0].width, 1);
    //     this.gameMultiplierTexts[0].scale = scale;
    // }



    // protected updateGameMultiplier(): void {
    //     //console.log(" spinData.respins[RespinIndex.value].gameMultipliers ", spinData.respins[RespinIndex.value].gameMultipliers);
    //     //this.multiplier1.text = spinData.respins[RespinIndex.value].gameMultipliers[0] ? spinData.respins[RespinIndex.value].gameMultipliers[0] + "X" : this.multiplier1.text;
    //     this.gameMultiplierValues = spinData.respins[RespinIndex.value].gameMultipliers;
    //     /* if (spinData.respins[RespinIndex.value].type == "fs_reveal" && fsInitIndex == RespinIndex.value) {

    //         this.playMultiFx(this.gameMultiplierFx[0]);
    //         this.gameMultiplierTexts[0].text = featureIMGlobal[0] + "X";

    //         if (this.gameMultiplierTexts[1].text === "") this.playMultiFx(this.gameMultiplierFx[1]);
    //         this.gameMultiplierTexts[1].text = featureIMGlobal[1] + "X";
    //         if (this.gameMultiplierTexts[2].text === "") this.playMultiFx(this.gameMultiplierFx[2]);
    //         this.gameMultiplierTexts[2].text = featureIMGlobal[2] + "X";
    //         if (this.gameMultiplierTexts[3].text === "") this.playMultiFx(this.gameMultiplierFx[3]);
    //         this.gameMultiplierTexts[3].text = featureIMGlobal[3] + "X";
    //     } else */

    //     {
    //         if (this.gameMultiplierTexts[0].text === "" && (this.gameMultiplierValues[0] ? true : false)) this.playMultiFx(this.gameMultiplierFx[0]);
    //         this.gameMultiplierTexts[0].text = this.gameMultiplierValues[0] ? this.gameMultiplierValues[0] + "X" : this.gameMultiplierTexts[0].text;

    //         if (this.gameMultiplierTexts[1].text === "" && (this.gameMultiplierValues[1] ? true : false)) this.playMultiFx(this.gameMultiplierFx[1]);
    //         this.gameMultiplierTexts[1].text = this.gameMultiplierValues[1] ? this.gameMultiplierValues[1] + "X" : this.gameMultiplierTexts[1].text;
    //         if (this.gameMultiplierTexts[2].text === "" && (this.gameMultiplierValues[2] ? true : false)) this.playMultiFx(this.gameMultiplierFx[2]);
    //         this.gameMultiplierTexts[2].text = this.gameMultiplierValues[2] ? this.gameMultiplierValues[2] + "X" : this.gameMultiplierTexts[2].text;
    //         if (this.gameMultiplierTexts[3].text === "" && (this.gameMultiplierValues[3] ? true : false)) this.playMultiFx(this.gameMultiplierFx[3]);
    //         this.gameMultiplierTexts[3].text = this.gameMultiplierValues[3] ? this.gameMultiplierValues[3] + "X" : this.gameMultiplierTexts[3].text;
    //         sound.play('multiplier_panel', { volume: 1 });
    //         this.setTheScleOfMainMultiplier();

    //     }



    // }


    // private async playMultiFx(fx: Spine): Promise<void> {
    //     fx.visible = true;
    //     fx.state.setAnimation(0, "multiplier_blast", false).listener = {
    //         complete: () => {
    //             fx.state.clearListeners();
    //             fx.visible = false;
    //         }
    //     }
    // }

    // protected async jumpAnimGameMultiplier(isSuperQuick: boolean): Promise<void> {

    //     const timeDuration = isSuperQuick ? 0.15 : 0.3;

    //     console.log(" in jumpAnimGameMultiplier spinData.respins[RespinIndex.value].gameMultipliers ", spinData.respins[RespinIndex.value].gameMultipliers);
    //     if (spinData.respins[RespinIndex.value].type == "reveal" || spinData.respins[RespinIndex.value].type == "fs_reveal")
    //         return;
    //     sound.play('multiplier_move', { volume: 1 });
    //     const currentSpinIndex = RespinIndex.value;
    //     this.gameMultiplierValues = spinData.respins[currentSpinIndex].gameMultipliers;
    //     const t1 = gsap.timeline({
    //         delay: 0, onComplete: () => {
    //             this.gameMultiplierTexts[0].text = this.gameMultiplierValues[0] ? this.gameMultiplierValues[0] + "X" : this.gameMultiplierTexts[0].text;
    //             this.gameMultiplierTexts[1].position.set(MULTIPLIER2_POS.x, MULTIPLIER2_POS.y);
    //             this.playMultiFx(this.gameMultiplierFx[0]);
    //             this.setTheScleOfMainMultiplier();
    //         }
    //     });
    //     t1.to(this.gameMultiplierTexts[1], {
    //         duration: timeDuration,
    //         motionPath: {
    //             path: [{ x: this.gameMultiplierTexts[1].position.x, y: this.gameMultiplierTexts[1].position.y }, { x: interpolate(this.gameMultiplierTexts[1].position, MULTIPLIER1_POS, 0.7).x, y: MULTIPLIER1_POS.y - 70 }, { x: MULTIPLIER1_POS.x, y: MULTIPLIER1_POS.y }],
    //             curviness: 1.5,
    //             autoRotate: false,
    //         },
    //         ease: 'power1.inOut'
    //     });
    //     const t2 = gsap.timeline({
    //         delay: 0, onComplete: () => {
    //             this.gameMultiplierTexts[1].text = this.gameMultiplierValues[1] ? this.gameMultiplierValues[1] + "X" : this.gameMultiplierTexts[1].text;
    //             this.gameMultiplierTexts[2].position.set(MULTIPLIER3_POS.x, MULTIPLIER3_POS.y);
    //             this.playMultiFx(this.gameMultiplierFx[1]);
    //         }
    //     });
    //     t2.to(this.gameMultiplierTexts[2], {
    //         duration: timeDuration,
    //         motionPath: {
    //             path: [{ x: this.gameMultiplierTexts[2].position.x, y: this.gameMultiplierTexts[2].position.y }, { x: interpolate(this.gameMultiplierTexts[2].position, MULTIPLIER2_POS, 0.7).x, y: MULTIPLIER2_POS.y - 70 }, { x: MULTIPLIER2_POS.x, y: MULTIPLIER2_POS.y }],
    //             curviness: 1.5,
    //             autoRotate: false,
    //         },
    //         ease: 'power1.inOut'
    //     });
    //     const t3 = gsap.timeline({
    //         delay: 0, onComplete: () => {
    //             this.gameMultiplierTexts[2].text = this.gameMultiplierValues[2] ? this.gameMultiplierValues[2] + "X" : this.gameMultiplierTexts[2].text;
    //             this.gameMultiplierTexts[3].text = "";
    //             this.gameMultiplierTexts[3].position.set(MULTIPLIER4_POS.x, MULTIPLIER4_POS.y);
    //             this.playMultiFx(this.gameMultiplierFx[2]);
    //         }
    //     });
    //     t3.to(this.gameMultiplierTexts[3], {
    //         duration: timeDuration,
    //         motionPath: {
    //             path: [{ x: this.gameMultiplierTexts[3].position.x, y: this.gameMultiplierTexts[3].position.y }, { x: interpolate(this.gameMultiplierTexts[3].position, MULTIPLIER3_POS, 0.7).x, y: MULTIPLIER3_POS.y - 70 }, { x: MULTIPLIER3_POS.x, y: MULTIPLIER3_POS.y }],
    //             curviness: 1.5,
    //             autoRotate: false,
    //         },
    //         ease: 'power1.inOut'
    //     });

    //     return new Promise<void>((resolve) => {
    //         this.gameMultiplierTexts[4].visible = true;
    //         this.gameMultiplierTexts[4].alpha = 0;
    //         this.gameMultiplierTexts[4].scale = 0;
    //         this.gameMultiplierTexts[4].text = this.gameMultiplierValues[3] ? this.gameMultiplierValues[3] + "X" : this.gameMultiplierTexts[3].text;
    //         const t4 = gsap.timeline({
    //             delay: 0, onComplete: () => {

    //                 this.gameMultiplierTexts[3].text = this.gameMultiplierValues[3] ? this.gameMultiplierValues[3] + "X" : this.gameMultiplierTexts[3].text;
    //                 this.gameMultiplierTexts[3].position.set(this.gameMultiplierTexts[4].x, this.gameMultiplierTexts[4].y);
    //                 this.gameMultiplierTexts[4].text = "";
    //                 this.gameMultiplierTexts[4].visible = true;
    //                 resolve();
    //             }
    //         });
    //         t4.to(this.gameMultiplierTexts[4], {
    //             duration: timeDuration,
    //             alpha: 1,
    //             ease: 'power1.inOut',
    //             onComplete: () => {
    //                 this.playMultiFx(this.gameMultiplierFx[3]);
    //             }
    //         });
    //         t4.to(this.gameMultiplierTexts[4].scale, {
    //             duration: timeDuration,
    //             x: 1,
    //             y: 1,
    //             ease: 'power1.inOut'
    //         });
    //     });

    // }
    // private setupMultiplierEffects(): void {
    //     const NoOfMultipliers: number = 4;
    //     for (let multiIndex = 0; multiIndex < NoOfMultipliers; multiIndex++) {

    //         const fx = Spine.from({
    //             skeleton: "multiplierBlastSkel",
    //             atlas: "multiplierBlastAtlas",
    //         });
    //         this.addChild(fx);
    //         // const animations = fx.skeleton.data.animations.map(anim => anim.name);
    //         // console.log("fx animations", animations)
    //         fx.state.setAnimation(0, "multiplier_blast", false).listener = {
    //             complete: () => {
    //                 fx.state.clearListeners();
    //                 fx.visible = false;
    //             }
    //         }
    //         this.gameMultiplierFx.push(fx);
    //     }
    //     this.gameMultiplierFx[0].position.set(MULTIPLIER1_POS.x, MULTIPLIER1_POS.y);
    //     this.gameMultiplierFx[1].position.set(MULTIPLIER2_POS.x, MULTIPLIER2_POS.y);
    //     this.gameMultiplierFx[2].position.set(MULTIPLIER3_POS.x, MULTIPLIER3_POS.y);
    //     this.gameMultiplierFx[3].position.set(MULTIPLIER4_POS.x, MULTIPLIER4_POS.y);
    // }

    // public resetMultipliers(): void {
    //     //if (spinData.respins[RespinIndex.value]?.type == "reveal") {
    //     this.gameMultiplierTexts[0].text = "";
    //     this.gameMultiplierTexts[1].text = "";
    //     this.gameMultiplierTexts[2].text = "";
    //     this.gameMultiplierTexts[3].text = "";
    //     this.gameMultiplierTexts[4].text = "";
    //     //}

    //     this.setTheScleOfMainMultiplier();
    // }

    // private setupMultipliers(): void {
    //     // this.multiplierContainer = new Container();
    //     // this.addChild(this.multiplierContainer);

    //     this.gameMultiplierTexts.push(this.setupMultiplier("", MULTIPLIER1_FONT, 1, MULTIPLIER1_POS.x, MULTIPLIER1_POS.y));
    //     this.gameMultiplierTexts.push(this.setupMultiplier("", MULTIPLIER2_FONT, 2, MULTIPLIER2_POS.x, MULTIPLIER2_POS.y));
    //     this.gameMultiplierTexts.push(this.setupMultiplier("", MULTIPLIER2_FONT, 3, MULTIPLIER3_POS.x, MULTIPLIER3_POS.y));
    //     this.gameMultiplierTexts.push(this.setupMultiplier("", MULTIPLIER2_FONT, 4, MULTIPLIER4_POS.x, MULTIPLIER4_POS.y));
    //     this.gameMultiplierTexts.push(this.setupMultiplier("", MULTIPLIER2_FONT, 4, MULTIPLIER4_POS.x, MULTIPLIER4_POS.y));
    //     this.gameMultiplierTexts[this.gameMultiplierTexts.length - 1].visible = false;
    // }

    // private getScale(containerWidth: number, actualWidth: number): number {
    //     return Math.min((containerWidth / actualWidth), 1);
    // }


    // private setupMultiplier(text: string, fontSize: number, index: number, xpos: number, ypos: number): BitmapText {
    //     const multiplier = new BitmapText({
    //         text: text,
    //         style: {
    //             fontFamily: 'symbol_multiplier',
    //             fontSize: fontSize
    //         }
    //     });
    //     multiplier.position.set(xpos, ypos);
    //     multiplier.anchor = 0.5;
    //     multiplier.label = "multiplier" + index;

    //     this.addChild(multiplier);

    //     // // --- Scale individually based on W/H limits ---
    //     // const scaleX = 140 / multiplier.width;
    //     // const scaleY = 50 / multiplier.height;

    //     // // pick the smaller so both width & height stay within bounds
    //     // const scaleFactor = Math.min(1, scaleX, scaleY);
    //     // multiplier.scale.set(scaleFactor);

    //     return multiplier;

    // }

    public initPaylineContainer(): void {
        this.paylineOverlayContainer = new Container();
        this.paylineOverlayContainer.x = this.allReelContainer.x;
        this.paylineOverlayContainer.y = this.allReelContainer.y;
        this.paylineOverlayContainer.label = "payline Container";
        this.addChild(this.paylineOverlayContainer);
    }


    public initReelOverlayContainer() {
        this.reelOverlayContainer = new Container();
        this.reelOverlayContainer.x = this.allReelContainer.x;
        this.reelOverlayContainer.y = this.allReelContainer.y;

        this.addChild(this.reelOverlayContainer);

        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.reelOverlayContainer.addChild(this.anticipation[i]);

            this.anticipation[i].x = REEL_FRAME + i * (REEL_WIDTH + REEL_DIVIDER);
            this.anticipation[i].y = REEL_FRAME;
        }
        this.wildBoundaryContainer = new Container();
        this.reelOverlayContainer.addChild(this.wildBoundaryContainer);
    }

    // public initReelOverlayContainer() {
    //     this.reelOverlayContainer = new Container();
    //     this.reelOverlayContainer.x = this.allReelContainer.x;
    //     this.reelOverlayContainer.y = this.allReelContainer.y;

    //     this.addChild(this.reelOverlayContainer);

    //     for (let i = 0; i < REEL_NUMBERS; i++) {
    //         this.reelOverlayContainer.addChild(this.anticipation[i]);
    //     }


    //     // comment
    //     // this.reelOverlayContainer.scale=0.5;
    //     // this.reelOverlayContainer.x = this.allReelContainer.x + 600;
    //     // this.reelOverlayContainer.y = this.allReelContainer.y + 400;

    // }


    // public addReelSymbolsToContainer(reelNum: number) {
    //     const reelObj = this.allReelArray[reelNum];
    //     // reelObj.container.visible = false;

    //     for (let j = 0; j < reelObj.symbols.length; j++) {

    //         const symbolObj = reelObj.symbols[j];

    //         const posNum = j;

    //         const symbolId =symbolObj.id;



    //         const winSymbol = getSpineSymbol(symbolId);

    //         winSymbol.y = REEL_FRAME + Math.round(SYMBOL_HEIGHT / 2) + posNum * SYMBOL_HEIGHT;
    //         winSymbol.x = REEL_FRAME + Math.round(SYMBOL_WIDTH / 2) + reelNum * (REEL_WIDTH + REEL_DIVIDER);
    //         winSymbol.label = `${reelNum * 3 + posNum}`;

    //         // console.log(`symbolId ${symbolId} reelNum ${reelNum } posNum ${ posNum}`);

    //         // if (!this.reelOverlayContainer.getChildByName(`${reelNum * 3 + posNum}`)) {
    //         //     this.reelOverlayContainer.addChild(winSymbol);
    //         // }

    //         // const existingSymbol = this.reelOverlayContainer.getChildByName(`${reelNum * 3 + posNum}`);
    //         // if (existingSymbol) {
    //         //     this.reelOverlayContainer.removeChild(existingSymbol)
    //         //     existingSymbol.destroy();
    //         // }

    //         // this.reelOverlayContainer.addChild(winSymbol);


    //     }

    //     // check for oversized symbols
    //     for (let i = 0; i <= reelNum; i++) {
    //         const currentReelObj = this.allReelArray[i];
    //         for (let j = 0; j < currentReelObj.symbols.length; j++) {
    //             const posNum = j;
    //             const symbolId = currentReelObj.symbols[posNum].id;
    //             if (isOversizeSymbol(symbolId)) { // symbolId of oversized symbols
    //                 const winSymbol: Spine | null = this.reelOverlayContainer.getChildByName(`${i * 3 + posNum}`) as Spine;
    //                 if (winSymbol) {
    //                     this.reelOverlayContainer.addChild(winSymbol);
    //                 }
    //             }
    //         }
    //     }
    // }



    // public addSymbolOverlayContainer (symbol : Spine, reelNum: number, posNum : number) {

    //     const winSymbol = symbol;

    //     winSymbol.y = REEL_FRAME + Math.round(SYMBOL_HEIGHT / 2) + posNum * SYMBOL_HEIGHT;
    //     winSymbol.x = REEL_FRAME + Math.round(SYMBOL_WIDTH / 2) + reelNum * (REEL_WIDTH + REEL_DIVIDER);
    //     winSymbol.label = `${reelNum * 3 + posNum}`;

    //     const existingSymbol = this.reelOverlayContainer.getChildByName(`${reelNum * 3 + posNum}`);
    //     if (existingSymbol) {
    //         this.reelOverlayContainer.removeChild(existingSymbol)
    //         existingSymbol.destroy();
    //     }

    //     this.reelOverlayContainer.addChild(winSymbol);

    //     this.resetWinContainer();

    // }

    // public resetWinContainer() {

    //     // this.allReelArray[reelNum].container.visible = false;
    //     for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {

    //         for (let j = 0; j < this.allReelArray[reelNum].symbols.length; j++) {


    //             const posNum = j;

    //             // console.log(`reelNum ${reelNum}`);
    //             // console.log(`posNum ${posNum}`);

    //             const symbolId: number = this.allReelArray[reelNum].symbols[posNum].id;
    //             const winSymbol = getSpineSymbol(symbolId);

    //             winSymbol.y = REEL_FRAME + Math.round(SYMBOL_HEIGHT / 2) + posNum * SYMBOL_HEIGHT;
    //             winSymbol.x = REEL_FRAME + Math.round(SYMBOL_WIDTH / 2) + reelNum * (REEL_WIDTH + REEL_DIVIDER);

    //             winSymbol.label = `${reelNum * 3 + posNum}`;

    //             if (this.reelOverlayContainer.getChildByLabel(`${reelNum * 3 + posNum}`)) {
    //                 //do nothing
    //             }
    //             else {
    //                 this.reelOverlayContainer.addChild(winSymbol)
    //             }


    //         }
    //     }

    //     // check for oversize symbols
    //     for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {

    //         for (let i = 0; i <= reelNum; i++) {
    //             const currentReelNum = i;
    //             for (let j = 0; j < this.allReelArray[currentReelNum].symbols.length; j++) {

    //                 const posNum = j;

    //                 const symbolId: number = this.allReelArray[currentReelNum].symbols[posNum].id;

    //                 if (isOversizeSymbol(symbolId)) // symbolId of oversized symbols
    //                 {
    //                     const winSymbol: Spine | null = this.reelOverlayContainer.getChildByLabel(`${currentReelNum * 3 + posNum}`) as Spine;
    //                     this.reelOverlayContainer.addChild(winSymbol)
    //                 }

    //             }
    //         }
    //     }
    // }






}

export class MyParticleLayer extends Container {
    constructor() {
        super();
        // You can add setup logic or child containers here
    }
}
